export default "__VITE_ASSET__CYXto2wX__"